import type { MapMarker, MapBounds, MapCenter } from './types';

export const calculateBounds = (markers: MapMarker[]): MapBounds | null => {
  if (markers.length === 0) return null;

  const latitudes = markers.map(m => m.latitude).filter(lat => lat != null);
  const longitudes = markers.map(m => m.longitude).filter(lng => lng != null);

  if (latitudes.length === 0 || longitudes.length === 0) return null;

  return {
    north: Math.max(...latitudes),
    south: Math.min(...latitudes),
    east: Math.max(...longitudes),
    west: Math.min(...longitudes),
  };
};

export const calculateCenter = (markers: MapMarker[]): MapCenter | null => {
  if (markers.length === 0) return null;

  const validMarkers = markers.filter(
    m => m.latitude != null && m.longitude != null
  );

  if (validMarkers.length === 0) return null;

  if (validMarkers.length === 1) {
    return {
      lat: validMarkers[0].latitude,
      lng: validMarkers[0].longitude,
      zoom: 10,
    };
  }

  const avgLat =
    validMarkers.reduce((sum, m) => sum + m.latitude, 0) / validMarkers.length;
  const avgLng =
    validMarkers.reduce((sum, m) => sum + m.longitude, 0) / validMarkers.length;

  return {
    lat: avgLat,
    lng: avgLng,
  };
};

export const visitsToMarkers = (
  visits: Array<{
    latitude?: number;
    longitude?: number;
    ip?: string;
    country?: string;
    visited_at?: any;
  }>
): MapMarker[] => {
  const markers: MapMarker[] = [];

  visits.forEach((visit, index) => {
    if (
      visit.latitude == null ||
      visit.longitude == null ||
      isNaN(visit.latitude) ||
      isNaN(visit.longitude)
    ) {
      return;
    }

    const title = visit.ip || `Visit ${index + 1}`;
    const description = [
      visit.country && `Country: ${visit.country}`,
      visit.visited_at &&
        `Visited: ${new Date(visit.visited_at).toLocaleString()}`,
    ]
      .filter(Boolean)
      .join('\n');

    markers.push({
      id: `visit-${index}`,
      latitude: visit.latitude,
      longitude: visit.longitude,
      title,
      description,
    });
  });

  return markers;
};

